import { FhsAxios } from "../../services/axios";
import { hasItBeenLoaded } from "@/helpers/loading";

export default {
  state: {
    reports: null
  },
  actions: {
    fetchAccountStatementList({ commit, getters, state }) {
      // Прерываем выполение, если данные уже загружены
      if (hasItBeenLoaded(state.reports)) {
        return;
      }

      FhsAxios.post("reports/account-statement-list", {}).then(response => {
        commit("setReports", response.data.result);
      });
    }
  },
  mutations: {
    setReports(state, payload) {
      state.reports = payload;
    }
  },
  getters: {
    reports(state) {
      return state.reports || [];
    },
    isReportsLoading(state) {
      return state.reports === null;
    }
  }
};
